export default __webpack_public_path__ + "static/media/yesMark.4c49a9eb.svg";